export default {
  langName: "Shqip",
  common: {
    company: "Një kompani e Eagle Inc",
    privacy: "Privatësia",
    terms: "Kushtet e përdorimit",
    support: "Mbështetje",
  },
  nav: {
    group: "Eagle Eyes Group",
    realEstate: "Real Estate",
    itManagement: "IT Management",
    digitalServices: "Digital Services",
    backToGroup: "Eagle Eyes Group",
    property: "Property",
    investment: "Investment",
  },
  form: {
    name: "Emri i plotë",
    email: "Adresa e emailit",
    sending: "Duke dërguar…",
    sent: "Faleminderit — të dhënat tuaja mbërritën. Do t'ju kontaktojmë së shpejti.",
    error: "Diçka shkoi keq. Provoni përsëri ose na shkruani direkt.",
  },
  gateway: {
    hero1: "EAGLE",
    hero2: "EYES",
    hero3: "GROUP",
    chapters: [
      { num: "01", name: "Real Estate", sub: "Property · Investment — Tirana", desc: "Banesa me qira të kujdesuara me kujdes dhe një qasje e verifikueshme dhe e disiplinuar ndaj investimeve imobiliare rezidenciale.", cta: "Hyni në Real Estate" },
      { num: "02", name: "IT Management", sub: "Konsulencë & shërbime të menaxhuara", desc: "Konsulencë IT senior në cloud, identitet, siguri dhe DevOps — e përcaktuar me saktësi, e dorëzuar personalisht, e menaxhuar afatgjatë.", cta: "Hyni në IT Management" },
      { num: "03", name: "Digital Services", sub: "Produkte që ndërtojmë dhe operojmë", desc: "Një portfolio në rritje produktesh web dhe mobile në social commerce, marketing dhe rezervime — të projektuara dhe operuara brenda nesh.", cta: "Hyni në Digital Services" },
    ],
    footerBrand: "Eagle Eyes Group",
  },
  re: {
    forClients: "Për klientët",
    propertyH: "Property",
    propertyP: "Banesa me qira në qendër të Tiranës, të gjetura dhe të kujdesuara me kujdes. Për njerëz që duan një vend për të jetuar, jo një transaksion.",
    propertyCta: "Hyni në Eagle Eyes Property",
    forInvestors: "Për investitorët",
    investmentH: "Investment",
    investmentP: "Një qasje e verifikueshme dhe e disiplinuar ndaj rezidencës së Tiranës. Për ata që duan të shohin saktësisht çfarë mbështesin.",
    investmentCta: "Hyni në Eagle Eyes Investment",
  },
  property: {
    kicker: "Eagle Eyes Property",
    h1: "Një shtëpi në Tiranë, e mbikëqyrur që nga fillimi.",
    intro: "Gjejmë, përgatisim dhe menaxhojmë apartamente me qira në qendër të Tiranës — për qiramarrës që duan një shtëpi të menaxhuar si duhet, jo thjesht një shpallje.",
    cta: "Bëhuni pjesë e listës së pritjes",
    navWhat: "Çfarë bëjmë",
    navHow: "Si funksionon",
    navJoin: "Bëhuni pjesë e listës",
    whatTitle: "Çfarë bën Eagle Eyes Property",
    whatMeta: "Onboarding në vazhdim · Shpalljet së shpejti",
    what: [
      { label: "Përzgjedhja", title: "Apartamente të përzgjedhura", text: "Çdo shtëpi zgjidhet dhe inspektohet në lagjet qendrore të Tiranës — pa kërkuar përmes shpalljeve që nuk qëndrojnë në person." },
      { label: "Menaxhimi", title: "Një pikë kontakti", text: "Mirëmbajtja, dokumentacioni dhe pyetjet kalojnë përmes një ekipi, jo një pronari të vështirë për t'u kontaktuar." },
      { label: "Transparenca", title: "Kushte të qarta, që në fillim", text: "Çmimet, kontratat dhe depozitat shpjegohen qartë përpara angazhimit — pa surpriza pas zhvendosjes." },
    ],
    howTitle: "Si funksionon",
    howMeta: "Tre hapa",
    steps: [
      { title: "Na tregoni çfarë kërkoni", text: "Buxheti, lagjja, madhësia, data e zhvendosjes — bazat që ngushtojnë vërtet kërkimin." },
      { title: "Ju përputhim me banesat e disponueshme", text: "Do të dëgjoni nga ne kur të kemi apartamente që përshtaten, jo një përmbytje opsionesh të gabuara." },
      { title: "Zhvendosuni, me mbështetje pas", text: "Nënshkruar, sistemuar, kujdesur — Eagle Eyes mbetet pika juaj e kontaktit për sa kohë të jeni me qira me ne." },
    ],
    waitTitle: "Shikoni apartamentet të parët",
    waitText: "Eagle Eyes Property po nis banesat e para në qendër të Tiranës. Lini të dhënat tuaja dhe do t'ju kontaktojmë sapo të hapen shpalljet.",
    neighbourhood: "Lagjja e preferuar (opsionale)",
    waitButton: "Bëhuni pjesë e listës së pritjes",
    waitNote: "Pa spam — vetëm një njoftim kur apartamentet të jenë të disponueshme.",
    footerBrand: "Eagle Eyes Property",
  },
  investment: {
    kicker: "Eagle Eyes Investment",
    h1: "Imobiliare rezidenciale në Tiranë, ndërtuar për t'u verifikuar.",
    intro: "Eagle Eyes blen dhe jep me qira apartamente në qendër të Tiranës përmes një entiteti holding shqiptar të strukturuar — i menaxhuar në mënyrë që çdo pohim të verifikohet, jo vetëm të merret si i mirëbesueshëm.",
    cta: "Kërkoni paketën informative",
    navThesis: "Si është ndërtuar",
    navTrack: "Track record",
    navContact: "Kontakt",
    thesisTitle: "Si është ndërtuar Eagle Eyes",
    thesisP1: "Blejmë apartamente në lagjet qendrore të Tiranës, i japim me qira qiramarrësve të verifikuar përmes Eagle Eyes Property dhe i mbajmë brenda një strukture të dedikuar shoqërie — duke ndarë pronësinë, menaxhimin dhe raportimin në mënyrë që secili të rishikohet veçmas.",
    thesisP2: "Qëllimi është një portfolio që rritet me qëllim: më pak blerje, secila e dokumentuar mjaftueshëm mirë sa një investitor të mund të rindërtojë arsyetimin tonë pa pasur nevojë të na besojë fjalës.",
    specs: [
      { k: "Pronësia", v: "Holding shqiptar / strukturë SPV" },
      { k: "Operacionet", v: "Të menaxhuara përmes Eagle Eyes Property" },
      { k: "Fokusi", v: "Apartamente rezidenciale në qendër të Tiranës" },
      { k: "Raportimi", v: "Dokumentacion i disponueshëm me kërkesë" },
    ],
    trackTitle: "Track record",
    trackMeta: "Blerjet e para në vazhdim",
    trackBoxTitle: "Rezultate objekt-për-objekt — së shpejti",
    trackBoxText: "Ndërsa apartamentet blihen, jepen me qira dhe (kur është e aplikueshme) shiten, secili do të listohet këtu me shifrat pas tij — kosto blerjeje, punime të kryera, okupim dhe kthim.",
    trackBoxNote: "Dëshironi statusin aktual përpara publikimit? Pyesni më poshtë.",
    verifyTitle: "Çfarë mund të shqyrtojnë investitorët e verifikuar",
    verify: [
      { label: "Entiteti", title: "Struktura korporative", text: "Dokumentet e regjistrimit të kompanisë holding dhe SPV-së, dhe si qëndron pronësia e çdo apartamenti nën to." },
      { label: "Asetet", title: "Detaje në nivel prone", text: "Vendndodhja, gjendja, kushtet e blerjes dhe statusi i qirasë për çdo apartament të mbajtur ose në ofertë." },
      { label: "Financat", title: "Shifrat nënështrore", text: "Kostot, kushtet e financimit dhe të ardhurat nga qiraja pas portofolit — të ndara direkt, jo të përmbledhura." },
      { label: "Njerëzit", title: "Kush qëndron pas", text: "Sfondi i atyre që drejtojnë Eagle Eyes dhe si lidhen anët Property dhe Investment mes tyre." },
    ],
    contactTitle: "Kërkoni të shihni detajet",
    contactText: "Na tregoni kush jeni dhe çfarë dëshironi të verifikoni. Do t'ju përgjigjemi direkt me dokumentacionin përkatës.",
    roleLabel: "Paraqiteni si…",
    roles: ["Një investitor potencial", "Një investitor ekzistues", "Tjetër / këshilltar"],
    verifyField: "Çfarë dëshironi të verifikoni? (opsionale)",
    contactButton: "Kërkoni informacion",
    contactNote: "Dokumentacioni ndahet direkt me individë të emëruar, nuk publikohet hapur.",
    footerBrand: "Eagle Eyes Investment",
  },
  it: {
    kicker: "IT Management",
    h1a: "Eagle Eyes",
    h1b: "IT Management",
    hero: "Konsulencë IT end-to-end e përshtatur me nevojat tuaja — nga zgjidhje të synuara me scope të vetëm dhe strategji gjithëpërfshirëse, deri te menaxhimi afatgjatë i portofolit dhe mirëmbajtja e vazhdueshme",
    heroCta: "Filloni një bisedë",
    navProcess: "Si angazhohemi",
    navExpertise: "Ekspertiza",
    navEngagements: "Angazhimet",
    profileTitle: "Profili",
    profile: "Eagle Eyes IT Management është një praktikë menaxhimi dhe konsulence që shërben klientëve në mbarë globin. Konsulentët tanë angazhohen direkt nga takimi i parë deri në dorëzimin final — duke mbuluar endpoint, identitet, menaxhim pajajtjesh, siguri dhe cloud hosting në Azure dhe Microsoft 365 — dhe mbeten përgjegjës për portofolin për të gjithë afatin e kontratës.",
    processTitle: "Si angazhohemi",
    process: [
      { num: "01", title: "Scope first", text: "Çdo angazhim fillon me kërkesën tuaj, takime ndjekëse dhe një scope të shkruar: deliverables, kritere pranimi, asgjë e paqartë." },
      { num: "02", title: "Discovery", text: "Një hetim i detajuar me orë konsulence të rrethuara, të faturuara paraprakisht, që përfundon me një propozim plotësisht të kostuar." },
      { num: "03", title: "Kontraktimi", text: "Shërbime të vetma të faturuara paraprakisht. Punë e vazhdueshme e përshtatur me organizatën tuaj. Menaxhim portofoli dhe mirëmbajtje me kontrata vjetore me faturim mujor. Kombinimet janë të negociueshme." },
    ],
    expertiseTitle: "Ekspertiza",
    expertise: [
      { title: "Modern workplace", items: "Windows 11 · Intune · Autopilot" },
      { title: "Microsoft 365", items: "Exchange · SharePoint · Teams · Migrime" },
      { title: "Siguria", items: "Defender · Hardening · Secrets · Patching" },
      { title: "Service management", items: "Jira · JSM · Confluence · Dizajn procesi" },
      { title: "Identity & access", items: "Entra ID · Conditional access · MFA · SSO" },
      { title: "Azure & hosting", items: "IaaS / PaaS · Networking · Domains · SSL" },
      { title: "DevOps & CI/CD", items: "Azure DevOps · Bitbucket · Pipelines" },
      { title: "IT management", items: "Dizajn shërbimi · Furnitorë · Buxhete" },
    ],
    engagementsTitle: "Angazhime të përzgjedhura afatgjata",
    engagements: [
      { client: "Ofrues multinacional i software-it gjuhësor", role: "IT Business Consultancy & Global DevOps Management", text: "Themelimi i filialit më të ri kombëtar dhe dizajni i arkitekturës globale IT të korporatës. Ky angazhim përfshiu rritjen e operacioneve lokale nga 5 në 60 profesionistë brenda 18 muajve, duke ndërtuar dhe udhëhequr njëkohësisht ekipet ndërfunksionale të DevOps dhe IT management që drejtojnë infrastrukturën e zyrave globale." },
      { client: "Autoritet global në inxhinierinë e software-it", role: "IT Cloud & DevOps Consultancy", text: "Strukturimi dhe efikasiteti i infrastrukturës IT korporative për një lider global të njohur në zhvillimin e software-it. Ky angazhim përfshiu ndërtimin nga zero i një ekosistemi DevOps me performancë të lartë dhe inxhinierimin e një infrastrukture datacenter hibride që mbështet mbi 500 përdorues të brendshëm." },
      { client: "Ofrues kombëtar shërbimesh enterprise", role: "IT Cloud Consultancy & VoIP Architecture", text: "Konsulencë teknike e integruar, in-house për klientë B2B tier-one dhe ofrues shërbimesh. Fokusi kryesor: dizajnimi dhe vendosja e arkitekturave VoIP shumë të shkallëzueshme dhe zgjidhjeve cloud me klasë enterprise." },
    ],
    contactTitle: "Filloni një bisedë",
    contactText: "Na tregoni për mjedisin tuaj dhe çfarë dëshironi të arrini. Përgjigjemi personalisht — zakonisht brenda një dite pune.",
    companyField: "Kompania (opsionale)",
    messageField: "Si mund t'ju ndihmojmë?",
    contactButton: "Dërgoni kërkesën",
    contactBlockTitle: "Kontakt",
    servicesTitle: "Shërbime & Aftësi",
    productsTitle: "Produkte & Marka",
    portfolioTitle: "Menaxhimi i Portofolit",
    services: ["Modern workplace", "Microsoft 365", "Siguria", "Service management", "Identity & access", "Azure & hosting", "DevOps & CI/CD", "IT management"],
    products: ["Microsoft 365", "Azure", "Entra ID", "Intune", "PowerShell", "Azure DevOps", "Bitbucket", "Postman", "Jira", "Jira Service Management", "Confluence", "Twilio", "Agora"],
    portfolio: ["Dizajn shërbimi", "Menaxhim furnitorësh", "Pronësi buxheti", "Mirëmbajtje & mbështetje", "Kontraktim vjetor", "Faturim mujor"],
    footerBrand: "Eagle Eyes IT Management",
  },
  digital: {
    kicker: "Eagle Eyes Digital Services",
    h1: "Produkte që ndërtojmë, operojmë dhe rrisim.",
    intro: "Digital Services është studio e produktit e Eagle Eyes: projektojmë, lansojmë dhe operojmë produktet tona web dhe mobile në social commerce, marketing dhe rezervime.",
    navPortfolio: "Portofoli",
    navDeals: "Oferta & Marketing",
    navContact: "Kontakt",
    appsTitle: "Portofoli",
    live: "Live",
    soon: "Së shpejti",
    capsTitle: "Çfarë ndërtojmë",
    caps: [
      { title: "Social commerce", text: "Kthimi i audiencave në klientë me picks dhe oferta të blishme." },
      { title: "Fushata & oferta", text: "Promovime me kohë të kufizuar të ndërtuara për ndarje dhe konvertim të shpejtë." },
      { title: "Rezervime & planifikim", text: "Takime, disponueshmëri dhe rikujtime pa fërkim." },
      { title: "Analitikë & njohuri", text: "Çdo produkt i matur nga kliku i parë te klienti i përsëritur." },
    ],
    studioTitle: "Një studio produkti in-house",
    studioText: "Digital Services projekton, ndërton dhe operon produktet e Eagle Eyes nga fillimi në fund — nga skica e parë te infrastruktura, mbështetja dhe rritja. Pa punë për klientë, pa agjenci: produktet tona, standardi ynë.",
    statProducts: "Produkte",
    statLive: "Live",
    statLaunching: "Duke u lansuar",
    apps: [
      { name: "Socialdeal", tag: "Oferta & marketing", status: "live", desc: "Socialdeal u jep bizneseve lokale një mënyrë të shpejtë për të publikuar oferta dhe fushata me kohë të kufizuar, të ndërtuara për ndarje sociale dhe konvertim direkt.", url: "https://www.socialdeal.al/", cta: "Vizitoni Socialdeal", features: ["Publikim ofertash me kohë të kufizuar", "I ndërtuar për ndarje sociale", "Flukse konvertimi direkt"] },
      { name: "BookItNow", tag: "Platformë rezervimi", status: "soon", desc: "BookItNow është produkti ynë më i ri: rezervime online të thjeshta dhe të shpejta për bizneset e shërbimeve — takime, disponueshmëri dhe rikujtime në një vend.", url: "", cta: "Së shpejti", features: ["Rezervim takimesh online", "Disponueshmëri live", "Rikujtime automatike"] },
      { name: "InContact", tag: "Telefoni SIP & PBX", status: "soon", desc: "InContact është sistemi ynë SIP & PBX: telefoni në cloud me numra biznesi, drejtim thirrjesh dhe radhë — i menaxhuar online, pa hardware në zyrë.", url: "", cta: "Së shpejti", features: ["SIP trunk & PBX hosted", "Drejtim thirrjesh & grupe", "Numra & voicemail online"] },
    ],
    contactTitle: "Punoni me ne",
    contactText: "Të interesuar për një produkt, partneritet ose pilot? Lini një mesazh dhe do t'ju përgjigjemi.",
    messageField: "Mesazhi juaj",
    contactButton: "Dërgoni mesazhin",
    footerBrand: "Eagle Eyes Digital Services",
  },
  inc: {
    hero1: "EAGLE",
    hero2: "INC",
    intro: "Një holding, dy grupe — ku shërbimi dhe zhvillimi bashkohen.",
    eyesBtn: "Eagle Eyes Group",
    eyesSub: "Real Estate · IT Management · Digital Services",
    eyesCta: "Hyni në Eagle Eyes Group",
    commerceBtn: "Eagle Commerce Group",
    commerceSub: "Socialdeal · BookItNow · InContact",
    commerceCta: "Hyni në Eagle Commerce Group",
    footerBrand: "Eagle Inc",
    footerLegal: "Eagle Inc Sh.P.K.",
    tagline: "Kompani holdingu",
  },
  commerce: {
    hero1: "EAGLE",
    hero2: "COMMERCE",
    hero3: "GROUP",
    intro: "Eagle Commerce Group projekton, lançon dhe operon produktet e veta të e-commerce — nga ofertat lokale te rezervimet dhe kontakti me klientët.",
    live: "Live",
    soon: "Së shpejti",
    visit: "Vizitoni",
    explore: "Zbulo",
    products: [
      { name: "Socialdeal", tag: "Oferta & marketing", status: "live", desc: "Oferta lokale dhe fushata marketingu — publikohen shpejt, ndahen në rrjete sociale, konvertohen direkt.", url: "https://www.socialdeal.al/", brand: "Eagle Commerce Socialdeal", h1: "Oferta lokale, bërë për t'u ndarë.", story: "Socialdeal u jep bizneseve lokale një mënyrë të shpejtë e sociale për të publikuar oferta me afat dhe fushata — ndërtuar për t'u shpërndarë, përshtatur për konvertim të drejtpërdrejtë.", points: ["Publikim ofertash me afat", "Ndërtuar për shpërndarje sociale", "Rrjedha konvertimi të drejtpërdrejta"] },
      { name: "BookItNow", tag: "Platformë rezervimi", status: "soon", desc: "Rezervime online të thjeshta e të shpejta për bizneset e shërbimeve — takime, disponueshmëri dhe rikujtime në një vend.", url: "", brand: "Eagle Commerce BookItNow", h1: "Rezervim, pa fërkim.", story: "BookItNow u mundëson bizneseve të shërbimeve të pranojnë takime online brenda pak minutash — disponueshmëri live, rikujtime automatike dhe një rrjedhë rezervimi që klientët e përfundojnë vërtet.", points: ["Rezervim takimesh online", "Disponueshmëri live", "Rikujtime automatike"] },
      { name: "InContact", tag: "Telefoni SIP & PBX", status: "soon", desc: "Telefoni cloud për bizneset: SIP trunk, PBX hosted dhe çdo numër në një vend.", url: "", brand: "Eagle Commerce InContact", h1: "Telefoni biznesi, pa hardware.", story: "InContact është një platformë e plotë SIP & PBX në cloud: numra biznesi, drejtim thirrjesh, radhë dhe voicemail — e menaxhuar online, pa hardware fizik.", points: ["SIP trunk & PBX hosted", "Drejtim & radhë thirrjesh", "Numra të menaxhuar online"] },
    ],
    footerBrand: "Eagle Commerce Group",
  },
};
